module.exports = __webpack_public_path__ + "img/60c475caa99bd2.17608420.7d94e840.png";